<p-card>
  <ng-template #title>{{ "measurement.insight.title" | translate }}</ng-template>
  <ng-template #subtitle>{{ "measurement.insight.subtitle" | translate }}</ng-template>

  @if (lastDataPoint(); as dp) {
    <div>
      <p class="h6 mb-3">{{ "measurement.corrosion.insights.last_data_point" | translate }}</p>
      <div class="data-row">
        <span class="data-label">{{ "measurement.corrosion.temperature" | translate }}:</span>
        <span class="data-value">{{ dp.temperature | number:'1.2-2' }} °C</span>
      </div>
      <div class="data-row">
        <span class="data-label">{{ "measurement.corrosion.humidity" | translate }}:</span>
        <span class="data-value">{{ dp.humidity | number:'1.2-2' }} %</span>
      </div>
      <div class="data-row">
        <span class="data-label">{{ "measurement.corrosion.potential" | translate }}:</span>
        <span class="data-value">{{ dp.potential | number:'1.2-2' }} mV</span>
      </div>
      <div class="data-row">
        <span class="data-label">{{ "measurement.corrosion.rp" | translate }}:</span>
        <span class="data-value">{{ dp.rp | number:'1.2-2' }} kΩ</span>
      </div>
      <div class="data-row">
        <span class="data-label">{{ "measurement.corrosion.rohm" | translate }}:</span>
        <span class="data-value">{{ dp.rohm | number:'1.2-2' }} Ω</span>
      </div>
      <div class="data-row">
        <span class="data-label">{{ "measurement.corrosion.last_ice" | translate }}:</span>
        <span class="data-value">{{ dp.last_ice | number:'1.2-2' }}</span>
      </div>
      <div class="data-row">
        <span class="data-label">{{ "measurement.corrosion.quality" | translate }}:</span>
        <span class="data-value">{{ dp.quality | number:'1.0-0' }}</span>
      </div>
    </div>
  }

  <p-divider></p-divider>

  <p class="mt-4">
    {{ 'measurement.lastSeen' | translate }}:
    @if (lastDataTime()) {
      <span>{{ lastDataTime() | date:'dd/MM/yyyy HH:mm:ss' }}</span>
    } @else {
      <span>{{ 'measurement.insight.no_data' | translate }}</span>
    }
  </p>

  @if (!lastDataPoint()) {
    <div>
      <p class="text-muted">{{ 'measurement.insight.no_data' | translate }}</p>
    </div>
  }
</p-card>
